<template>
    <!-- 개인정보취급방침 -->
    <div class="terms" v-html="this.content"></div>
</template>

<script>
import { fetchData } from '@/utils/fetchData';
export default {
    mixins: [ fetchData ],
    data(){
        return {
            content: '',
        }
    },
    created(){
        this.fetchData('/getPolicy?page=privacy', (data)=>{
            this.content = data.policy.content;
        })
    }
}
</script>